import { render } from "./TermsOfService.vue?vue&type=template&id=0fb4e992&scoped=true"
const script = {}

import "./TermsOfService.vue?vue&type=style&index=0&id=0fb4e992&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fb4e992"]])

export default __exports__